export const heatRankIds = [
  "tangerines",
  "queen-of-tears",
  "squid-game-3",
  "the-glory",
  "lovely-runner",
  "when-the-phone-rings",
  "crash-landing",
  "marry-my-husband",
  "reply-1988",
  "goblin"
];

export const ratingRankIds = [
  "reply-1988",
  "tangerines",
  "hospital-playlist",
  "stranger",
  "signal",
  "the-glory",
  "prison-playbook",
  "crash-landing",
  "queen-of-tears",
  "my-liberation-notes"
];

export const scheduleDays = [
  {
    day: "周一",
    highlight: false,
    shows: [
      { title: "苦尽柑来遇见你", info: "第 9-10 集 · 全平台更新", tag: "家庭" },
      { title: "秘密森林", info: "经典重刷 · 会员专享", tag: "悬疑" }
    ]
  },
  {
    day: "周二",
    highlight: false,
    shows: [{ title: "现在拨打的电话", info: "第 7-8 集 · 更新", tag: "悬疑" }]
  },
  {
    day: "周三",
    highlight: true,
    shows: [
      { title: "苦尽柑来遇见你", info: "第 11-12 集 · 全平台更新", tag: "家庭" },
      { title: "我的解放日志", info: "经典重刷 · 更新", tag: "治愈" }
    ]
  },
  {
    day: "周四",
    highlight: false,
    shows: [{ title: "背着善宰跑", info: "第 9-10 集 · 更新", tag: "青春" }]
  },
  {
    day: "周五",
    highlight: true,
    shows: [
      { title: "鱿鱼游戏 第三季", info: "全集放出 · 会员抢先", tag: "惊悚" },
      { title: "社内相亲", info: "经典重刷 · 更新", tag: "爱情" }
    ]
  },
  {
    day: "周六",
    highlight: false,
    shows: [
      { title: "眼泪女王", info: "第 13-14 集 · 更新", tag: "爱情" },
      { title: "二十五，二十一", info: "经典重刷 · 更新", tag: "青春" }
    ]
  },
  {
    day: "周日",
    highlight: false,
    shows: [{ title: "机智的医生生活", info: "经典重刷 · 更新", tag: "医疗" }]
  }
];

export const editorPicks = [
  {
    id: "tangerines",
    headline: "年度最佳：把苦日子熬成橘子酱",
    blurb: "《苦尽柑来遇见你》用济州岛的风、柑橘园的四季和两代人的坚守，讲了一个关于“熬”的故事。它不急着让你哭，却在某个平凡的清晨让你突然红了眼眶。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20sunlit%20tangerine%20orchard%20on%20Jeju%20island%2C%20rows%20of%20orange%20trees%2C%20warm%20golden%20afternoon%20light%2C%20nostalgic%20film%20grain%2C%20muted%20warm%20tones%2C%20editorial%20photography&width=900&height=560&seq=kd-edit-01&orientation=landscape"
  },
  {
    id: "my-liberation-notes",
    headline: "写给所有被生活磨平的人",
    blurb: "如果你也曾在通勤路上放空，在深夜怀疑自己，《我的解放日志》会像一句温柔的“我懂”。它没有爽感，只有缓慢而真实的自我和解。",
    image: "https://readdy.ai/api/search-image?query=Serene%20wide%20shot%20of%20a%20quiet%20suburban%20rice%20field%20at%20sunset%20in%20Korea%2C%20lone%20figure%20walking%20a%20path%2C%20soft%20pastel%20sky%2C%20melancholic%20peaceful%20mood%2C%20muted%20olive%20tones&width=900&height=560&seq=kd-edit-02&orientation=landscape"
  },
  {
    id: "queen-of-tears",
    headline: "成年人的爱情，是又痛又舍不得",
    blurb: "《眼泪女王》把婚姻里那些说不出口的委屈与心软拍得格外真实。金秀贤与金智媛的对手戏张力十足，甜虐之间让人一口气追到深夜。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20wide%20interior%20of%20a%20luxurious%20marble%20mansion%20hall%20at%20dusk%2C%20warm%20chandelier%20glow%2C%20rose%20and%20gold%20palette%2C%20refined%20romantic%20cinematic%20mood%2C%20editorial&width=900&height=560&seq=kd-edit-03&orientation=landscape"
  }
];

export const newReleases = [
  {
    id: "tangerines",
    date: "2025.03.07",
    note: "济州岛柑橘园家庭史诗，开播即登顶站内口碑榜。",
    badge: "本季口碑"
  },
  {
    id: "squid-game-3",
    date: "2025.06.27",
    note: "生存游戏终局回归，全集放出，讨论度居高不下。",
    badge: "完结放送"
  },
  {
    id: "lovely-runner",
    date: "2024.04.08",
    note: "粉丝穿越救偶像的青春奇幻爱情，甜度与遗憾并存。",
    badge: "人气新剧"
  },
  {
    id: "when-the-phone-rings",
    date: "2024.11.22",
    note: "政治联姻夫妻的悬疑爱情，节奏紧凑、反转不断。",
    badge: "年度黑马"
  },
  {
    id: "marry-my-husband",
    date: "2024.01.01",
    note: "重生复仇爽剧代表作，开年讨论度快速攀升。",
    badge: "复仇爽剧"
  },
  {
    id: "queen-of-tears",
    date: "2024.03.09",
    note: "财阀夫妻的婚姻复合记，收视与话题双丰收。",
    badge: "现象级"
  }
];

export const faqs = [
  {
    q: "韩剧TV 上的“最新韩剧”是怎么更新的？",
    a: "本站按照剧集的正常放送节奏整理更新信息，通常在剧集播出后不久同步更新条目与剧情简介。追更日历分区列出了本周各天的更新安排，你可以据此安排观看时间。"
  },
  {
    q: "“站内热度”和“口碑评分”有什么区别？",
    a: "站内热度反映近期浏览、收藏与讨论的综合表现，更新快、波动大；口碑评分更侧重长期稳定的观众评价。想追当下热门看热度榜，想找耐看的经典看评分榜。"
  },
  {
    q: "怎么快速找到合我口味的剧？",
    a: "有两个办法：一是在首屏搜索框输入剧名或演员名直接筛选；二是在“按题材选剧”分区点击题材标签，页面会即时过滤出相应剧集，筛选只作用于本页已有内容。"
  },
  {
    q: "首页的剧单会一直变化吗？",
    a: "热播榜会随更新节奏动态调整，高分剧单相对稳定。经典剧集即使完结也会长期保留在剧单中，方便新观众补剧。"
  },
  {
    q: "我该从哪里开始入门韩剧？",
    a: "如果刚接触韩剧，可以从《请回答1988》《爱的迫降》《机智的医生生活》这类口碑稳定、门槛较低的作品入手，再根据自己喜欢的题材（爱情、悬疑、治愈等）逐步拓展。"
  },
  {
    q: "订阅追更提醒之后会收到什么？",
    a: "订阅后我们会在重要剧集更新或新剧开播时发送提醒邮件，内容以更新剧名、播出集数与一句话简介为主，不发送与追剧无关的信息，你也可以随时取消订阅。"
  }
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Cinematic%20dark%20wide%20banner%20of%20a%20rainy%20Seoul%20city%20street%20at%20night%2C%20glowing%20neon%20signs%20in%20warm%20amber%20and%20rose%20tones%2C%20wet%20asphalt%20reflections%2C%20moody%20dramatic%20atmosphere%2C%20abstract%20artistic%20commercial%20photography&width=1920&height=1080&seq=kd-hero-main&orientation=landscape";

export const statItems = [
  { value: "2,800+", label: "在库韩剧资源" },
  { value: "120+", label: "本周更新剧集" },
  { value: "48万", label: "追剧观众" },
  { value: "4.9分", label: "用户平均评分" }
];